import { CacheConfig, RequestParameters, UploadableMap, Variables } from 'relay-runtime';
import config from 'src/shared/config';

export const isMutation = (request: RequestParameters) => request.operationKind === 'mutation';
export const isQuery = (request: RequestParameters) => request.operationKind === 'query';
export const forceFetch = (cacheConfig: CacheConfig) => !!(cacheConfig && cacheConfig.force);

export const handleData = (response: any) => {
    const contentType = response.headers.get('content-type');
    if ((contentType && contentType.indexOf('application/json') !== -1) || contentType.indexOf('application/graphql-response+json') !== -1) {
        return response.json();
    }

    return response.text();
};

function getRequestBodyWithUploadables(request: RequestParameters, variables: Variables, uploadables?: UploadableMap) {
    let formData = new FormData();
    formData.append('name', request.name);
    formData.append('operations', JSON.stringify({ query: request.text || '', variables }));
    formData.append('map', JSON.stringify({}));

    if (uploadables) {
        Object.keys(uploadables).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(uploadables, key)) {
                formData.append(key, uploadables[key]);
            }
        });
    }

    return formData;
}

function getRequestBodyWithoutUplodables(request: RequestParameters, variables: Variables) {
    return JSON.stringify({
        name: request.name, // used by graphql mock on tests
        query: request.text, // GraphQL text from input
        variables
    });
}

export function getRequestBody(request: RequestParameters, variables: Variables, uploadables?: UploadableMap | null) {
    if (uploadables) {
        return getRequestBodyWithUploadables(request, variables, uploadables);
    }

    return getRequestBodyWithoutUplodables(request, variables);
}

export const getHeaders = (uploadables?: UploadableMap | null): HeadersInit => {
    if (uploadables) {
        return {
            Accept: '*/*',
            Authorization: 'Bearer ' + config.token
        };
    }

    return {
        Authorization: 'Bearer ' + config.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': config.culture
    };
};
